import { render, staticRenderFns } from "./EmailTemplateDetail.vue?vue&type=template&id=4ea3ca54&scoped=true"
import script from "./EmailTemplateDetail.vue?vue&type=script&lang=js"
export * from "./EmailTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplateDetail.vue?vue&type=style&index=0&id=4ea3ca54&lang=scss&scoped=true"
import style1 from "./EmailTemplateDetail.vue?vue&type=style&index=1&id=4ea3ca54&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3ca54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea3ca54')) {
      api.createRecord('4ea3ca54', component.options)
    } else {
      api.reload('4ea3ca54', component.options)
    }
    module.hot.accept("./EmailTemplateDetail.vue?vue&type=template&id=4ea3ca54&scoped=true", function () {
      api.rerender('4ea3ca54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/EmailTemplateDetail.vue"
export default component.exports